import {
	fontSize16,
	gridGutter,
	gridGutterHalf
} from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";
import { grayFont } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";

export const defaultStyle = `
  .box-title {      
    font-size: ${fontSize16};
    color: ${grayFont};
    font-weight: bold;
    margin-bottom: ${gridGutter}px;
  }

  .row {
    margin-bottom: ${gridGutterHalf}px;
  }
`;
